import { useIsAuthenticated } from '@zageno/auth';
import { useQuery } from '@tanstack/react-query';
import { User } from './models';
import queryClient from './queryClient';
import { currentUserQuery } from './queries';

// eslint-disable-next-line import/prefer-default-export
export function useCurrentUser(): null | User {
  const isAuthenticated = useIsAuthenticated();

  // run query only if authentication status was established
  const { data, isPending } = useQuery(currentUserQuery(isAuthenticated !== null), queryClient);

  if (isPending) {
    return null;
  }

  return {
    ...data.data,
    logged_in: isAuthenticated,
    first_name: isAuthenticated ? data?.data.first_name : '',
    last_name: isAuthenticated ? data?.data.last_name : '',
    email: isAuthenticated ? data?.data.email : '',
    user_id: isAuthenticated ? data?.data.user_id : '',
    org_id: isAuthenticated ? data?.data.org_id : '',
    org_key: isAuthenticated ? data?.data.org_key : '',
    org_name: isAuthenticated ? data?.data.org_name : '',
    can_manage_organization: isAuthenticated ? data?.data.can_manage_organization : false,
    has_approval_flow_enabled: isAuthenticated ? data?.data.has_approval_flow_enabled : false,
    has_self_service_enabled: isAuthenticated ? data?.data.has_self_service_enabled : false,
  } as User;
}
